import Hero from './components/Hero';
import TopPickCard from './components/TopPickCard';
import CategoryNavigation from './components/CategoryNavigation';
import RankingList from './components/RankingList';
import ConfusedPick from './components/ConfusedPick';
import ComparisonTable from './components/ComparisonTable';
import CategorySelection from './components/CategorySelection';
import PurposeRecommend from './components/PurposeRecommend';
import SelectionGuide from './components/SelectionGuide';
import CampaignSection from './components/CampaignSection';
import ArticleSection from './components/ArticleSection';
import AboutSite from './components/AboutSite';
import GlobalHeader from '../../components/feature/GlobalHeader';
import GlobalFooter from '../../components/feature/GlobalFooter';
import SEO from '../../components/base/SEO';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "クレジットカード比較ナビ",
      "url": siteUrl,
      "description": "クレジットカードの比較・ランキング情報を提供する総合サイト。年会費無料、高還元率、学生向けなど、あなたにぴったりのカードが見つかります。",
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${siteUrl}/ranking?q={search_term_string}`,
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "クレジットカード比較ナビ",
      "url": siteUrl,
      "logo": `${siteUrl}/vite.svg`,
      "description": "クレジットカードの比較・ランキング情報を提供する総合サイト"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="クレジットカード比較｜2026年最新おすすめランキング"
        description="年会費無料・高還元率・学生向けなど目的別におすすめクレジットカードを比較。初心者でも失敗しない選び方を解説。三井住友カード、大手ECモール系カード、高還元率カードなど人気カードを徹底比較。"
        keywords="クレジットカード,比較,ランキング,おすすめ,年会費無料,高還元率,学生向け,即日発行"
        canonical="/"
        structuredData={structuredData}
      />
      <GlobalHeader />
      <Hero />
      <TopPickCard />
      <CategoryNavigation />
      <RankingList />
      <ConfusedPick />
      <ComparisonTable />
      <CategorySelection />
      <PurposeRecommend />
      <SelectionGuide />
      <CampaignSection />
      <ArticleSection />
      <AboutSite />
      <GlobalFooter />
    </div>
  );
}
